import {
  FETCH_CLIENT_USERS_MIGRATION_REQUEST,
  FETCH_CLIENT_USERS_MIGRATION_SUCCESS,
  FETCH_CLIENT_USERS_MIGRATION_FAILURE,
  POST_CLIENT_USERS_MIGRATION_REQUEST,
  POST_CLIENT_USERS_MIGRATION_SUCCESS,
  POST_CLIENT_USERS_MIGRATION_FAILURE,
  FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_REQUEST,
  FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_SUCCESS,
  FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_FAILURE
} from './clientUsersMigrationTypes';
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';

export const getClientUsersMigration = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [FETCH_CLIENT_USERS_MIGRATION_REQUEST, FETCH_CLIENT_USERS_MIGRATION_SUCCESS, FETCH_CLIENT_USERS_MIGRATION_FAILURE],
      authenticated: true,
      endpoint: 'api/admin/migration/clientUsers',
      method: 'GET'
    }
  };
};

export const postClientUserMigration = request => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_CLIENT_USERS_MIGRATION_REQUEST, POST_CLIENT_USERS_MIGRATION_SUCCESS, POST_CLIENT_USERS_MIGRATION_FAILURE],
      authenticated: true,
      endpoint: 'api/admin/migration/clientUsers',
      method: 'POST',
      payload: request
    }
  };
};

export const getClientContactMigrationHistory = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_REQUEST, FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_SUCCESS, FETCH_CLIENT_CONTACT_MIGRATION_HISTORY_FAILURE],
      authenticated: true,
      endpoint: 'api/admin/migration/clientUsers/history',
      method: 'GET'
    }
  };
};
